import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import './assets/css/fonts.css'

createApp(App).mount('#app')
